import React from 'react';
import { Text } from '@shopify/polaris';
import DismissableBanner from './DismissableBanner';

// Reassures merchants after the PHP and Node.js vulnerabilities of October 2026, which Shopify asked every app to
// check for. The Disco app runs on .NET. Shown through November, while the news is recent; a dismissal outlasts that.
export const SHOW_UNTIL = new Date(2026, 10, 30, 23, 59, 59);

const SecurityNoticeBanner = ({ now = new Date() }) => {
  if (now > SHOW_UNTIL) return null;

  return (
    <DismissableBanner
      propName="securityNotice2026Oct"
      expiryHrs={60 * 24}
      tone="info"
      title="Disco isn't affected by the recent PHP and Node.js vulnerabilities"
    >
      <Text as="p">
        Disco doesn't run on PHP or Node.js, so these issues don't affect the app or your store. We've also
        completed Shopify's recommended security checks and found no issues.
      </Text>
    </DismissableBanner>
  );
};

export default SecurityNoticeBanner;
